import React, {useEffect, useState} from "react";
import {fetchUser} from "../services/api";
import AuthForm from "./AuthForm";

function AppBody() {

  const [data, updateData] = useState();

  useEffect(() => {
    const getLinkedUserData = () => {
      fetchUser().then((res: any) => {
        updateData(res);
      });
    }
    getLinkedUserData();
  }, []);

  return <AuthForm data={data}/>;

};

export default AppBody;
